import { createTheme } from '@material-ui/core/styles'

// Create a theme instance.
const theme = createTheme({
  palette: {
    primary: {
      main: '#82c341'
    },
    secondary: {
      main: '#7938A1'
    }
  },
  typography: {
    fontFamily: "'Montserrat', sans-serif"
  },
  overrides: {
    MuiContainer: {
      maxWidthXl: {
        '@media only screen and (max-width: 1920px)': {
          maxWidth: '1440px !important'
        }
      },
      maxWidthLg: {
        '@media only screen and (max-width: 1920px)': {
          maxWidth: '1200px !important'
        }
      }
    },
    MuiDialog: {
      paper: {
        borderRadius: 8
      },
      paperWidthMd: {
        maxWidth: 734
      },
      paperScrollPaper: {
        maxHeight: 762
      }
    },
    MuiDialogTitle: {
      root: {
        padding: 16,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '& > .MuiIconButton-root': {
          top: 6,
          color: 'rgba(0, 0, 0, 0.54)',
          right: 0,
          position: 'absolute'
        },
        '& .MuiSvgIcon-root': {
          fontSize: 21
        }
      }
    },
    MuiDialogContent: {
      root: {
        background:
          'linear-gradient(90deg, rgb(244, 244, 244) 96.8%, rgb(255, 255, 255) 96.8%)'
      },
      dividers: {
        padding: 40,
        borderTop: '1px solid rgb(0 0 0 / 0.12)',
        borderBottom: 0
      }
    },
    MuiDialogActions: {
      root: {
        padding: 24,
        "& > .btn[type='outlined-primary']": {
          width: 168
        }
      }
    }
  }
})

export default theme
